/**
 * @registry Explicit status-panel/badge colors for RFI statuses that have no workflow step (e.g. the "More Information Needed" revise-return status at stepIndex -1; Draft already resolves to gray via resolveLifecycleColor). Feed the keys to useWorkflowStatusFilters as extraStatuses and the map to useWorkflowStatusSegments; use the map to supply a badge buttonColor fallback when the row has no step.
 */
export const RFI_STATUS_COLORS: Record<string, string> = {
  'More Information Needed': 'orange',
};
